module.exports = __webpack_public_path__ + "static/media/checkbox_checked.ee1be590.svg";